module.exports = __webpack_public_path__ + "img/logoWindows_c.3a64f699.svg";